import styled from 'styled-components';

import { flexAllCenter } from 'styles/mixins';
import { COLORS } from 'styles/style-constants';

export const Container = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    height: 4rem;
    width: 4rem;
    border-radius: 50%;
    border: 0.1rem solid ${COLORS.gray100};
    background-color: ${COLORS.tokenChipBackground};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transform: translate(-50%, -50%);

    &:hover {
        border: 0.1rem solid ${COLORS.textGray};
    }
`;

export const RevertButton = styled.div`
    cursor: pointer;
    padding: 1rem;
    border-radius: 0.3rem;
    ${flexAllCenter};
`;
